import React from "react";
import { CardIconProps } from "./CardIcon.types";
import { MapTo } from "@adobe/aem-react-editable-components";
import { useIsMobile } from "src/utils/js/useIsMobile";
import { HeadingTag, RangoCard, RangoIcon, RangoTopicIcon } from "@rango/core";
import { CardIconContainer } from "./CardIcon.styles";

const CardIcon: React.FC<CardIconProps> = ({
	icon,
	alt,
	title,
	description,
	id,
}) => {

	return (
		<>
			{icon && (
				<CardIconContainer>
					<RangoTopicIcon
						className="card-container"
						id={id}
						alt={alt}
						icon={icon}
						paragraph={description}
						headingProps={{
							children: title,
							tag: HeadingTag.H2,
						}}
					/>
				</CardIconContainer>
			)}
		</>
	);
};

const CardIconConfig = {
	emptyLabel: "Card Ícone",
	isEmpty: function (props: CardIconProps) {
		return !props || !props.icon;
	},
};

MapTo<CardIconProps>("alelo/components/content/v1/card-icon")(CardIcon, CardIconConfig);

export default CardIcon;
